import React, { useState, useEffect } from "react";
import Images from "../images";
import LazyImg from "./LazyImg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";

import "swiper/css";
import "swiper/css/navigation";
import { Autoplay } from "swiper/modules";

const MedEngageSummit1819 = () => {
  const [showAll, setShowAll] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // 🎖 Winners data
  const winnersData = [
    {
      name: "Riti Sanghvi",
      category: "Champion of the Champions",
      color: "warning",
      icon: "fa-crown",
    },
    {
      name: "Sufyan Ibra",
      category: "Champion of the Champions",
      color: "warning",
      icon: "fa-crown",
    },
    {
      name: "Antariksh Vijan",
      category: "Pedagogue",
      color: "primary",
      icon: "fa-chalkboard-teacher",
    },
    {
      name: "Ashish Gupta",
      category: "Pedagogue",
      color: "primary",
      icon: "fa-chalkboard-teacher",
    },
    {
      name: "Aravindan Murugesan",
      category: "Wiz Kid",
      color: "success",
      icon: "fa-lightbulb",
    },
    {
      name: "Rakesh Penta",
      category: "Wiz Kid",
      color: "success",
      icon: "fa-lightbulb",
    },
    {
      name: "Rahul Kumar",
      category: "Wiz Kid",
      color: "success",
      icon: "fa-lightbulb",
    },
    {
      name: "Shivangi Gandhi",
      category: "Wiz Kid",
      color: "success",
      icon: "fa-lightbulb",
    },
    {
      name: "Smit Vakil",
      category: "Wiz Kid",
      color: "success",
      icon: "fa-lightbulb",
    },
    {
      name: "Vaidehi Chavan",
      category: "Wiz Kid",
      color: "success",
      icon: "fa-lightbulb",
    },
    {
      name: "Shrinidhi Nathany",
      category: "Scholar Collar",
      color: "secondary",
      icon: "fa-book",
    },
    {
      name: "Arnav Saroya",
      category: "Scholar Collar",
      color: "secondary",
      icon: "fa-book",
    },
    {
      name: "Amrita Gupta",
      category: "Scholar Collar",
      color: "secondary",
      icon: "fa-book",
    },
    {
      name: "Jainam Shah",
      category: "The Vibrant One",
      color: "danger",
      icon: "fa-bolt",
    },
    {
      name: "Diva Sharma",
      category: "The Vibrant One",
      color: "danger",
      icon: "fa-bolt",
    },
    {
      name: "Avinash Kashid",
      category: "The Vibrant One",
      color: "danger",
      icon: "fa-bolt",
    },
    {
      name: "Parantap J Trivedi",
      category: "Wordsmith",
      color: "info",
      icon: "fa-pen",
    },
    {
      name: "Nisar Ahamed",
      category: "Wordsmith",
      color: "info",
      icon: "fa-pen",
    },
    {
      name: "Parul Sharma",
      category: "Wordsmith",
      color: "info",
      icon: "fa-pen",
    },
  ];

  // ⭐ Star Observers 2018 data
  const starObservers2018 = [
    { name: "Ms. Stephy Alex", mentor: "Dr Parijat Gupte" },
    { name: "Mr. Aryan Vora", mentor: "Ms. Neha Bhudia" },
    { name: "Ms. Sakshi Haria", mentor: "Ms. Manish Jaysing" },
    { name: "Dr Keyoor", mentor: "Dr Prathamesh Desai" },
    { name: "Dr Akshay Agarwal", mentor: "Ms. Malaika Mathur" },
    { name: "Dr Ravi Mohanka", mentor: "Chirag Vazirani" },
    { name: "Dr T Santosh", mentor: "—" },
  ];

  const [selectedMember, setSelectedMember] = useState(null);

  const teamMembers = [
    {
      name: "Prof (Col) Prabal deb",
      img: Images.Prabal,
      shortInfo: "Dr. T. P. Lahane is a renowned eye surgeon",
      longInfo:
        "Prof (Col) Prabal Deb has contributed significantly in medical research and education. He has trained hundreds of students and continues to inspire young doctors.",
    },
    {
      name: "Dr. Anita S. Bhaduri",
      img: Images.Anita,
      shortInfo: "Dr. Anita S. Bhaduri Consultant Histopathologist.",
      longInfo:
        "Dr. Anita S. Bhaduri is a leading Consultant Histopathologist with decades of experience in pathology and research. She has published numerous papers and trained medical professionals.",
    },
    {
      name: "C. H. Unnikrishnan",
      img: Images.Unnikrishnan,
      shortInfo: "Founder and editor of Future Medicine magazine",
      longInfo:
        "C. H. Unnikrishnan is the founder and editor of Future Medicine magazine, playing a key role in science communication and medical journalism.",
    },
    {
      name: "Neeraj Gangal",
      img: Images.Neeraj,
      shortInfo:
        "Director of Student Engagement at Liberal and Management Education (Flame) University.",
      longInfo:
        "Neeraj Gangal works as Director of Student Engagement at FLAME University, actively engaging in academic and leadership development for students.",
    },
  ];
  const combinedData = [
    ...winnersData.map((w) => ({ ...w, type: "winner" })),
    ...starObservers2018.map((s) => ({ ...s, type: "observer" })),
  ];
  const Glimpse = [
    {
      img: Images.Glimps1,
      text: "Dr. Sushil Shah, Founder & Chairman Metropolis Healthcare Ltd, shares a light moment with Dr. O.P. Kapoor",
    },
    {
      img: Images.Glimps2,
      text: "Ms. Ameera Shah, MD, Promoter & Managing Director, Metropolis Healthcare Ltd, addresses the esteemed guests",
    },
    {
      img: Images.Glimps3,
      text: "(From L to R)- Dr. Kirti Chadha, Dr. Nilesh Shah, Ms. Ameera Shah & Dr. Sushil Shah along with the students",
    },
    {
      img: Images.Glimps4,
      text: "(From L to R) Mr.Vijender Singh & Mr. Neeraj Gangal, Forbes India, with students and their parents.",
    },
    {
      img: Images.Glimps5,
      text: "Dr. O.P. Kapoor awarding the certificate and trophy to Mr. Sufyan Ibra",
    },
    {
      img: Images.Glimps6,
      text: "Dr. Partha Guha Roy awarding the certificate and trophy to Ms. Vaidehi Chavan",
    },
    {
      img: Images.Glimps7,
      text: "Dr Amita Joshi awarding the trophy to Mr. Smit Vakil",
    },
    {
      img: Images.Glimps8,
      text: "Dr. J.K. Maniar conferring the certificate and trophy to Mr. Antariksh Vijan",
    },
    {
      img: Images.Glimps9,
      text: "Dr. Amita Joshi presenting the certificate and trophy to Mr. Aravindan Murugesan",
    },
    {
      img: Images.Glimps10,
      text: "Dr. O. P. Doshi awarding the certificate and trophy to Ms. Amrita Gupta",
    },
    {
      img: Images.Glimps11,
      text: "Dr. J. K. Maniar awarding the certificate and trophy to Mr. Ashish Gupta",
    },
    {
      img: Images.Glimps12,
      text: "Dr. O.P. Kapoor bestowing Ms. Riti Sanghvi’s father with the Cheque and trophy",
    },
    {
      img: Images.Glimps13,
      text: "Dr. J. K. Maniar awarding the certificate and trophy to Mr. Parantap J Trivedi",
    },
    {
      img: Images.Glimps14,
      text: "Dr Sangeeta Pikale presenting the trophy to Ms. Shrinidhi Nathany",
    },
    {
      img: Images.Glimps15,
      text: "Dr Manoj Gandhi awarding the certificate and trophy to Mr. Sajid Sheikh",
    },
    {
      img: Images.Glimps16,
      text: "Dr. Raj Harjani awarding the certificate and trophy to Ms. Shivangi Gandhi",
    },
    {
      img: Images.Glimps17,
      text: "Dr. Nilesh Shah presenting certificate to Mr. Arnav Saroya’s mother",
    },
    {
      img: Images.Glimps18,
      text: "Dr. Raj Harjani awarding the certificate and trophy to Mr. Rakesh P",
    },
  ];

  const visibleGlimpss = showAll ? Glimpse : Glimpse.slice(0, 9);

  useEffect(() => {
    document.title = "Summit 2018 - MedEngage";
  }, []);
  const [loading, setLoading] = useState(true);

  // ✅ useEffect instead of React.useEffect
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 300); // loader disappears after 2s

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading && (
        <div
          className="fixed-top w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50"
          style={{ zIndex: 9999 }}
        >
          <div className="custom-spinner"></div>
        </div>
      )}
      <div>
        <section className="ul-breadcrumb ul-section-spacing">
          <div className="ul-container">
            <h2 className="ul-breadcrumb-title">MedEngage Summit 2018</h2>
            <ul className="ul-breadcrumb-nav">
              <li>
                <Link to="/">Home</Link>
              </li>

              <li>
                <span className="separator">
                 <i className="fa fa-arrow-right"></i>
                </span>
              </li>
              <li>MedEngage Summit 2018</li>
            </ul>
          </div>
        </section>

        <section className="ul-about ul-section-spacing ">
          <div className="ul-container">
            <div className="row row-cols-md-2 row-cols-1 align-items-center gy-4 ul-about-row">
              <div className="col">
                <div className="ul-about-txt">
                  <h2 className="ul-section-title">
                    Summit{" "}
                    <span>
                      <strong className="green">2018</strong>
                    </span>
                  </h2>

                  <p className="ul-section-descr">
                    On the 9th of December in Mumbai, the inaugural MedEngage
                    Summit was a huge success, marked by the presence of
                    industry experts and student winners from across the
                    country. The overwhelming response from students has
                    inspired us to continue hosting these summits every year
                    with the same enthusiasm.
                  </p>
                  <p className="ul-section-descr">
                    We were honored to welcome over 200 esteemed guests from the
                    industry, along with students nationwide, who came together
                    to witness the grand inaugural edition of this summit.
                  </p>
                  <p className="ul-section-descr">
                    While addressing the award ceremony, Dr. Sushil Shah,
                    Founder & Chairman of Metropolis Healthcare, shared, “In my
                    student years, I observed many bright students could not
                    pursue medical science due to financial difficulties.
                    Through MedEngage, we aim to support aspiring medical
                    students financially via scholarships and research funding.
                    We also believe students pursuing undergraduate or graduate
                    programs in medical science should be exposed to modern
                    technology, as the current syllabus often feels outdated.
                  </p>
                </div>
              </div>

              <div className="col">
                <div className="ul-about-imgs">
                  <div className="img-wrapper">
                    <LazyImg
                      src={Images.ScholorshipImage}
                      alt="Scholarship"
                      className="scholarship-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="stats-section">
          <div className="container">
            <h2 className="ul-section-title text-white text-center main-heading">
              MedEngage Reach
            </h2>
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-number">500+</div>
                <div className="stat-label">
                  <span className="text-muted">
                    Institutes Registered for the MedEngage program from all
                    across the globe
                  </span>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-number">6+ Countries</div>
                <div className="stat-label">
                  <span className="text-muted">
                    We received registrations from India, Zambia, Ghana, China,
                    Russia, Japan
                  </span>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-number">752 Applications</div>
                <div className="stat-label">
                  <span className="text-muted">
                    {" "}
                    Reviewed by an Internal Committee chaired by eminent doctors
                    from reputed external bodies.
                  </span>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-number">4500+</div>
                <div className="stat-label">
                  <span className="text-muted">
                    {" "}
                    Students registered to avail various benefits.
                  </span>
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-number">200 Shortlisted</div>
                <div className="stat-label">
                  <span className="text-muted">
                    {" "}
                    Selected on the basis of academic performance,
                    posters/papers published, journal contributions, and
                    extracurricular achievements.
                  </span>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-number">50 Students</div>
                <div className="stat-label">
                  <span className="text-muted">
                    {" "}
                    Finalists were determined basis responses they gave on a
                    topic the jury chose and final 50 students were shortlisted.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="ul-about ul-section-spacing">
          <div className="container">
            <h2 className="ul-section-title text-center main-heading">
              What <span className="text-success">is MedEngage?</span>
            </h2>

            <div className="position-relative text-white p-4 p-md-5 student-experience bg-gradient-to-br">
              {/* Decorative circles */}
              <div className="decor-circle top-right"></div>
              <div className="decor-circle bottom-left"></div>

              <div className="position-relative z-1">
                {/* Quote */}
                <blockquote className="fst-italic mb-3 quote-block">
                  “ MEDENGAGE is an effort by Metropolis to engage and partner
                  with medical students who essentially form the future
                  way-forward supporting the world class laboratory assistance
                  to raise the bar of academic research in the country. This is
                  a part of the company’s social initiatives to bring changes
                  and improve the healthcare research and academic landscape in
                  India."
                </blockquote>
              </div>
            </div>
          </div>
        </section>
        <section className="ul-about ul-section-spacing bg-light py-5">
          <div className="container">
            <h2 className="ul-section-title text-dark text-center main-heading">
              Complete Winners{" "}
              <span className="text-success">& Star Observers-2018</span>
            </h2>

            <Swiper
              modules={[Autoplay]}
              autoplay={{ delay: 2500, disableOnInteraction: false }}
              spaceBetween={15} // slightly reduced spacing
              slidesPerView={1}
              breakpoints={{
                576: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                992: { slidesPerView: 4 },
              }}
            >
              {combinedData.map((item, index) => (
                <SwiperSlide key={index}>
                  <div
                    className="card text-center shadow-sm h-100"
                    style={{
                      borderRadius: "1.2rem", // slightly smaller rounding
                      border: "none",
                      padding: "1rem", // reduced padding
                      minHeight: "220px", // ensure minimum height
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div className="card-body d-flex flex-column justify-content-between h-100">
                      <LazyImg
                        src={
                          item.type === "winner" ? Images.Trophy : Images.Star
                        }
                        alt={item.name}
                        className="mb-3 mx-auto"
                        style={{
                          width: item.type === "winner" ? "35px" : "40px",
                          height: item.type === "winner" ? "35px" : "40px",
                          objectFit: "cover",
                        }}
                      />

                      <h5
                        className="card-title mb-2 text-truncate"
                        title={item.name}
                      >
                        {item.name}
                      </h5>

                      {item.type === "winner" ? (
                        <span className="badge bg-success rounded-pill px-3 py-1">
                          {item.category}
                        </span>
                      ) : (
                        <span className="badge bg-success text-light rounded-pill px-3 py-1">
                          Mentor: {item.mentor}
                        </span>
                      )}
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>

        <section className="py-5 bg-dark">
          <div className="container">
            <h2 className="ul-section-title text-white text-center main-heading">
              Categories And Description Of Awards
            </h2>

            <div className="row g-4">
              {[
                {
                  img: Images.Icon1,
                  title: "Wordsmith",
                  desc: "The Wordsmith Scholarship Award is given to a deserving student who is able to skillfully articulate his thoughts into words.",
                },
                {
                  img: Images.Icon2,
                  title: "The Vibrant One",
                  desc: "The ‘Vibrant One’ Award is given to a deserving student who participates enthusiastically in extracurricular activities apart from academic brilliance.",
                },
                {
                  img: Images.Icon3,
                  title: "Scholar Collar",
                  desc: "The ‘Scholar Collar’ Award is given to a deserving student who participates enthusiastically in poster & paper presentations and consistently contributes to journals and research publications.",
                },
                {
                  img: Images.Icon4,
                  title: "WizKid",
                  desc: "The ‘WizKid’ Award is given to a deserving student who has consistently performed and delivered excellence in a particular branch of science.",
                },
                {
                  img: Images.Icon5,
                  title: "Champion of the Champion",
                  desc: "The ‘Champion of the Champion’ Award is given to a deserving student who has consistently delivered outstanding performance in academics, participated in poster, paper, journals and research publications along with pursuing other interests.",
                },
                {
                  img: Images.Icon6,
                  title: "Pedagogue",
                  desc: "The ‘Pedagogue’ Award is given to a deserving student who has consistently delivered outstanding performance in academics.",
                },
              ].map((award, index) => (
                <div key={index} className="col-12 col-sm-6 col-lg-4">
                  <div className="card h-100 bg-light text-dark shadow-sm rounded-4 p-3 d-flex flex-column flex-md-row align-items-center">
                    <LazyImg
                      src={award.img}
                      alt={award.title}
                      className="img-fluid mb-3 mb-md-0 me-md-3"
                      style={{
                        width: "80px",
                        height: "80px",
                        objectFit: "contain",
                      }}
                    />
                    <div className="text-center text-md-start">
                      <h5 className="fw-bold mb-2">{award.title}</h5>
                      <p className="mb-0 awardcard-description">{award.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* TEAM SECTION START */}

        <section className="ul-team ul-section-spacing">
          <div className="ul-container">
            <div className="ul-section-heading justify-content-center">
              <div className="left">
                <h2 className="ul-section-title text-center main-heading">
                  <span className="green">Jury </span> Profile 2018-19
                </h2>
              </div>
            </div>

            <div className="row g-2 g-sm-3 g-md-4 row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 ul-team-row justify-content-center">
              {teamMembers.map((member, idx) => (
                <div className="col" key={idx}>
                  <div className="ul-team-member">
                    <div className="ul-team-member-img">
                      <LazyImg
                        src={member.img}
                        alt={member.name}
                        className=""
                      />
                    </div>
                    <div className="ul-team-member-info text-center p-3">
                      <h3 className="ul-team-member-name mb-2">
                        <span className="text-dark">{member.name}</span>
                      </h3>
                      <p className="thumb-p mb-3 doctor-info">
                        {member.shortInfo}
                      </p>
                      <button
                        className="btn btn-link text-success text-decoration-none thumb-p"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#memberModal"
                        onClick={() => setSelectedMember(member)}
                      >
                        Read More
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Beautified Bootstrap Modal */}
          <div
            className="modal fade"
            id="memberModal"
            tabIndex="-1"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content border-0 shadow-lg rounded-4">
                {selectedMember && (
                  <>
                    <div className="modal-header border-0 pb-0">
                      <h4 className="modal-title fw-bold text-success">
                        {selectedMember.name}
                      </h4>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body text-center px-4">
                      <LazyImg
                        src={selectedMember.img}
                        alt={selectedMember.name}
                        className="img-fluid rounded-circle shadow-sm mb-4 image-size"
                      />
                      <p className="fs-5 text-muted">
                        {selectedMember.longInfo}
                      </p>
                    </div>
                    <div className="modal-footer border-0 justify-content-center">
                      <button
                        type="button"
                        className="btn btn-outline-secondary px-4 rounded-pill"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
        {/* Bootstrap Modal */}
        <div
          className="modal fade"
          id="memberModal"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content border-0 shadow-lg rounded-4">
              {selectedMember && (
                <>
                  {/* Header */}
                  <div className="modal-header border-0 pb-0">
                    <h4 className="modal-title fw-bold text-primary">
                      {selectedMember.name}
                    </h4>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>

                  {/* Body */}
                  <div className="modal-body text-center px-4">
                    <LazyImg
                      src={selectedMember.img}
                      alt={selectedMember.name}
                      className="img-fluid rounded-circle shadow-sm mb-4 image-size"
                    />
                    <p className="fs-6 text-muted">{selectedMember.longInfo}</p>
                  </div>

                  {/* Footer */}
                  <div className="modal-footer border-0 justify-content-center">
                    <button
                      type="button"
                      className="btn btn-outline-secondary px-4 rounded-pill"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        {/* TEAM SECTION END */}
        <section className="ul-section-spacing">
          <div className="container">
            <h2 className="ul-section-title text-center text-dark mb-5">
              Few <span className="green">Glimpse</span> From The Event
            </h2>

            <div className="row g-4">
              {visibleGlimpss.map((item, index) => (
                <div key={index} className="col-12 col-md-4">
                  <div className="card h-100 border-0 rounded-4 shadow-sm overflow-hidden">
                    <LazyImg
                      src={item.img}
                      alt="Event Glimpse"
                      className="card-img-top img-fluid rounded-top"
                    />
                    <div className="card-body">
                      <p className="card-text text-dark">{item.text}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {Glimpse.length > 9 && (
              <div className="text-center mt-4">
                <button
                  className="btn-view"
                  onClick={() => setShowAll(!showAll)}
                >
                  {showAll ? "View Less" : "View More"}
                </button>
              </div>
            )}
          </div>
        </section>
        {/* MEDTALKS & WEBINARS SECTION START */}
        <div className="ul-section-spacing">
          <div className="ul-container">
            <div className="ul-donate-form-section">
              <div className="row justify-content-center align-items-center">
                <div className="col-lg-12 text-white text-center">
                  <h3 className="mb-4">Testimonials</h3>

                  {/* Tabs */}
                  <ul
                    className="nav nav-tabs justify-content-center mb-4"
                    id="medtalkTabs"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active text "
                        id="students-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#students"
                        type="button"
                        role="tab"
                      >
                        Students
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="doctors-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#doctors"
                        type="button"
                        role="tab"
                      >
                        Doctors
                      </button>
                    </li>
                  </ul>

                  {/* Tab Content */}
                  <div className="tab-content" id="medtalkTabsContent">
                    {/* Students Tab */}
                    <div
                      className="tab-pane fade show active"
                      id="students"
                      role="tabpanel"
                    >
                      <div className="row g-3 justify-content-center">
                        <div className="col-sm-6 col-md-2">
                          <div className="speaker-card text-light h-100">
                            <div className="position-relative">
                              <a
                                href="https://youtu.be/S-aAR2iRCCk" // student video link
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <LazyImg
                                  src="https://img.youtube.com/vi/S-aAR2iRCCk/hqdefault.jpg"
                                  alt="Student Video 1"
                                  className="img-fluid rounded-top thumb-size"
                                />
                                <div className="video-play-icon">
                                  <i className="fa fa-play text-dark fs-6"></i>
                                </div>
                              </a>
                            </div>
                            <div className="p-3">
                              <h6 className="text-light semi">Arvind</h6>
                              <p className="thumb-p text-light">
                                How MEDENGAGE inspires ?
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-2">
                          <div className="speaker-card text-light h-100">
                            <div className="position-relative">
                              <a
                                href="https://youtu.be/BWFcM3_yF0Y" // student video link
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <LazyImg
                                  src="https://img.youtube.com/vi/BWFcM3_yF0Y/hqdefault.jpg"
                                  alt="Student Video 1"
                                  className="img-fluid rounded-top thumb-size"
                                />
                                <div className="video-play-icon">
                                  <i className="fa fa-play text-dark fs-6"></i>
                                </div>
                              </a>
                            </div>
                            <div className="p-3">
                              <h6 className="text-light semi">Rakesh</h6>
                              <p className="thumb-p text-light">
                                How MEDENGAGE inspires ?
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-2">
                          <div className="speaker-card text-light h-100">
                            <div className="position-relative">
                              <a
                                href="https://youtu.be/UOz1Mdr8oTw" // student video link
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <LazyImg
                                  src="https://img.youtube.com/vi/UOz1Mdr8oTw/hqdefault.jpg"
                                  alt="Student Video 1"
                                  className="img-fluid rounded-top thumb-size"
                                />
                                <div className="video-play-icon">
                                  <i className="fa fa-play text-dark fs-6"></i>
                                </div>
                              </a>
                            </div>
                            <div className="p-3">
                              <h6 className="text-light semi">Smith</h6>
                              <p className="thumb-p text-light">
                                How MEDENGAGE inspires ?
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-2">
                          <div className="speaker-card text-light h-100">
                            <div className="position-relative">
                              <a
                                href="https://youtu.be/it6a-VCqCXI" // student video link
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <LazyImg
                                  src="https://img.youtube.com/vi/it6a-VCqCXI/hqdefault.jpg"
                                  alt="Student Video 1"
                                  className="img-fluid rounded-top thumb-size"
                                />
                                <div className="video-play-icon">
                                  <i className="fa fa-play text-dark fs-6"></i>
                                </div>
                              </a>
                            </div>
                            <div className="p-3">
                              <h6 className="text-light semi">Rahul</h6>
                              <p className="thumb-p text-light">
                                How MEDENGAGE inspires ?
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-2">
                          <div className="speaker-card text-light h-100">
                            <div className="position-relative">
                              <a
                                href="https://youtu.be/Sqw94XT-AdY" // student video link
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <LazyImg
                                  src="https://img.youtube.com/vi/Sqw94XT-AdY/hqdefault.jpg"
                                  alt="Student Video 1"
                                  className="img-fluid rounded-top thumb-size"
                                />
                                <div className="video-play-icon">
                                  <i className="fa fa-play text-dark fs-6"></i>
                                </div>
                              </a>
                            </div>
                            <div className="p-3">
                              <h6 className="text-light semi">Sufiyan</h6>
                              <p className="thumb-p text-light">
                                How MEDENGAGE inspires ?
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-2">
                          <div className="speaker-card text-light h-100">
                            <div className="position-relative">
                              <a
                                href="https://youtu.be/tHQq3SmI6VU" // student video link
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <LazyImg
                                  src="https://img.youtube.com/vi/tHQq3SmI6VU/hqdefault.jpg"
                                  alt="Student Video 1"
                                  className="img-fluid rounded-top thumb-size"
                                />
                                <div className="video-play-icon">
                                  <i className="fa fa-play text-dark fs-6"></i>
                                </div>
                              </a>
                            </div>
                            <div className="p-3">
                              <h6 className="text-light semi">Shivangi</h6>
                              <p className="thumb-p text-light">
                                How MEDENGAGE inspires ?
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-2">
                          <div className="speaker-card text-light h-100">
                            <div className="position-relative">
                              <a
                                href="https://youtu.be/d04c0828ujg" // student video link
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <LazyImg
                                  src="https://img.youtube.com/vi/d04c0828ujg/hqdefault.jpg"
                                  alt="Student Video 1"
                                  className="img-fluid rounded-top thumb-size"
                                />
                                <div className="video-play-icon">
                                  <i className="fa fa-play text-dark fs-6"></i>
                                </div>
                              </a>
                            </div>
                            <div className="p-3">
                              <h6 className="text-light semi">Shrinidhi</h6>
                              <p className="thumb-p text-light">
                                How MEDENGAGE inspires ?
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-2">
                          <div className="speaker-card text-light h-100">
                            <div className="position-relative">
                              <a
                                href="https://youtu.be/HMYVazfyrE8" // student video link
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <LazyImg
                                  src="https://img.youtube.com/vi/HMYVazfyrE8/hqdefault.jpg"
                                  alt="Student Video 1"
                                  className="img-fluid rounded-top thumb-size"
                                />
                                <div className="video-play-icon">
                                  <i className="fa fa-play text-dark fs-6"></i>
                                </div>
                              </a>
                            </div>
                            <div className="p-3">
                              <h6 className="text-light semi">Ashish</h6>
                              <p className="thumb-p text-light">
                                How MEDENGAGE inspires ?
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-2">
                          <div className="speaker-card text-light h-100">
                            <div className="position-relative">
                              <a
                                href="https://youtu.be/wt3NgOn2fOQ" // student video link
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <LazyImg
                                  src="https://img.youtube.com/vi/wt3NgOn2fOQ/hqdefault.jpg"
                                  alt="Student Video 1"
                                  className="img-fluid rounded-top thumb-size"
                                />
                                <div className="video-play-icon">
                                  <i className="fa fa-play text-dark fs-6"></i>
                                </div>
                              </a>
                            </div>
                            <div className="p-3">
                              <h6 className="text-light semi">Parantap</h6>
                              <p className="thumb-p text-light">
                                How MEDENGAGE inspires ?
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-2">
                          <div className="speaker-card text-light h-100">
                            <div className="position-relative">
                              <a
                                href="https://youtu.be/BvZC4sLf-bI" // student video link
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <LazyImg
                                  src="https://img.youtube.com/vi/BvZC4sLf-bI/hqdefault.jpg"
                                  alt="Student Video 1"
                                  className="img-fluid rounded-top thumb-size"
                                />
                                <div className="video-play-icon">
                                  <i className="fa fa-play text-dark fs-6"></i>
                                </div>
                              </a>
                            </div>
                            <div className="p-3">
                              <h6 className="text-light semi">Amrita</h6>
                              <p className="thumb-p text-light">
                                How MEDENGAGE inspires ?
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-2">
                          <div className="speaker-card text-light h-100">
                            <div className="position-relative">
                              <a
                                href="https://youtu.be/hfQUUv36B4w" // student video link
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <LazyImg
                                  src="https://img.youtube.com/vi/hfQUUv36B4w/hqdefault.jpg"
                                  alt="Student Video 1"
                                  className="img-fluid rounded-top thumb-size"
                                />
                                <div className="video-play-icon">
                                  <i className="fa fa-play text-dark fs-6"></i>
                                </div>
                              </a>
                            </div>
                            <div className="p-3">
                              <h6 className="text-light semi">Sajid</h6>
                              <p className="thumb-p text-light">
                                How MEDENGAGE inspires ?
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-2">
                          <div className="speaker-card text-light h-100">
                            <div className="position-relative">
                              <a
                                href="https://youtu.be/4pkoSwWuWWc" // student video link
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <LazyImg
                                  src="https://img.youtube.com/vi/4pkoSwWuWWc/hqdefault.jpg"
                                  alt="Student Video 1"
                                  className="img-fluid rounded-top thumb-size"
                                />
                                <div className="video-play-icon">
                                  <i className="fa fa-play text-dark fs-6"></i>
                                </div>
                              </a>
                            </div>
                            <div className="p-3">
                              <h6 className="text-light semi">Vaidehi</h6>
                              <p className="thumb-p text-light">
                                How MEDENGAGE inspires?
                              </p>
                            </div>
                          </div>
                        </div>
                        {/* Repeat 11 more student cards like above */}
                      </div>
                    </div>

                    {/* Doctors Tab */}
                    <div className="tab-pane fade" id="doctors" role="tabpanel">
                      <div className="row g-3 justify-content-center">
                        {/* === Add 4 doctor videos here === */}
                        <div className="col-sm-6 col-md-3">
                          <div className="speaker-card text-light h-100">
                            <div className="position-relative">
                              <a
                                href="https://youtu.be/L6nWD5Iy7Pc" // doctor video link
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src="https://img.youtube.com/vi/L6nWD5Iy7Pc/hqdefault.jpg" // doctor thumbnail
                                  alt="Doctor Video 1"
                                  className="img-fluid rounded-top thumb-size"
                                />
                                <div className="video-play-icon">
                                  <i className="fa fa-play text-dark fs-6"></i>
                                </div>
                              </a>
                            </div>
                            <div className="p-3">
                              <h6 className="text-light semi">Dr.Hamzawala</h6>
                              <p className="thumb-p text-light">
                                Experience at the MEDENGAGE summit
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-3">
                          <div className="speaker-card text-light h-100">
                            <div className="position-relative">
                              <a
                                href="https://youtu.be/jEcVcLsmhpI" // doctor video link
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src="https://img.youtube.com/vi/jEcVcLsmhpI/hqdefault.jpg" // doctor thumbnail
                                  alt="Doctor Video 1"
                                  className="img-fluid rounded-top thumb-size"
                                />
                                <div className="video-play-icon">
                                  <i className="fa fa-play text-dark fs-6"></i>
                                </div>
                              </a>
                            </div>
                            <div className="p-3">
                              <h6 className="text-light semi">
                                Dr.Manish Hinduja
                              </h6>
                              <p className="thumb-p text-light">
                                Experience at the MEDENGAGE summit
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-3">
                          <div className="speaker-card text-light h-100">
                            <div className="position-relative">
                              <a
                                href="https://youtu.be/GFQulvIFx2M" // doctor video link
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src="https://img.youtube.com/vi/GFQulvIFx2M/hqdefault.jpg" // doctor thumbnail
                                  alt="Doctor Video 1"
                                  className="img-fluid rounded-top thumb-size"
                                />
                                <div className="video-play-icon">
                                  <i className="fa fa-play text-dark fs-6"></i>
                                </div>
                              </a>
                            </div>
                            <div className="p-3">
                              <h6 className="text-light semi">
                                Dr. Partha Guharay
                              </h6>
                              <p className="thumb-p text-light">
                                Experience at the MEDENGAGE summit
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-3">
                          <div className="speaker-card text-light h-100">
                            <div className="position-relative">
                              <a
                                href="https://youtu.be/FFO1435mhrc" // doctor video link
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src="https://img.youtube.com/vi/FFO1435mhrc/hqdefault.jpg" // doctor thumbnail
                                  alt="Doctor Video 1"
                                  className="img-fluid rounded-top thumb-size"
                                />
                                <div className="video-play-icon">
                                  <i className="fa fa-play text-dark fs-6"></i>
                                </div>
                              </a>
                            </div>
                            <div className="p-3">
                              <h6 className="text-light semi">
                                Dr.Ritika Hinduja
                              </h6>
                              <p className="thumb-p text-light">
                                MedTalk / Webinar Topic for Doctors
                              </p>
                            </div>
                          </div>
                        </div>
                        {/* Repeat 3 more doctor cards like above */}
                      </div>
                    </div>
                  </div>
                  {/* End Tab Content */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* MEDTALKS & WEBINARS SECTION END */}
      </div>
    </>
  );
};

export default MedEngageSummit1819;
